import OnboardCandidateList from "./onboardCandidateList";
export default OnboardCandidateList;